import React from 'react';
import Slider, {SliderProps} from 'rc-slider';
import {useTranslation} from 'react-i18next';

import {Handle} from './SliderHandle';

export function FeeSlider(props: SliderProps): React.ReactElement {
  const {t} = useTranslation();
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between font-inter text-base leading-5 font-medium mb-1">
        <span>{props.min}%</span>
        <span>{props.max}%</span>
      </div>
      <Slider
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        handle={({ref: _ref, dragging: _dragging, ...props}) => (
          <Handle {...props} />
        )}
        trackStyle={{
          background: '#315eff',
          height: 8,
          borderRadius: 10,
        }}
        railStyle={{
          height: 8,
          borderRadius: 10,
          background: '#ececec',
        }}
        {...props}
      />
      <div className="font-inter text-base leading-5 font-medium mt-5">
        {t('platformFee.feeAmountText', {
          value: props.value ?? props.defaultValue,
          defaultValue: 'I will pay {{ value }}% Wellnite Platform Fee',
        })}
      </div>
    </div>
  );
}
